import PlanPagoUniversidadService from '../services/plan-pago-universidad.service';
import PagoUniversidadService from '../services/pago-universidad.service';

export default {
  data() {
    return {
      detallePagoConceptoUniversidadCuotaAnterior: null,
      pagosUniversidadesCuotaAnterior: [],
    };
  },
  computed: {
    inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior() {
      const inscripcionesProgramasUniversidadesPagadas = [];

      this.pagosUniversidadesCuotaAnterior.forEach((pagoUniversidad) => {
        pagoUniversidad.detallesPagosUniversidades.forEach((detallePagoUniversidad) => {
          inscripcionesProgramasUniversidadesPagadas.push(
            detallePagoUniversidad.detalleSolicitudPago.inscripcionProgramaUniversidad,
          );
        });
      });

      return inscripcionesProgramasUniversidadesPagadas;
    },
  },
  methods: {
    async obtenerDetallePagoConceptoUniversidadCuotaAnterior(
      planPagoUniversidadId,
      detallePlanPagoConceptoUniversidadId,
    ) {
      await this.obtenerDatosMixin(
        PlanPagoUniversidadService.findOneDetallePlanPagoConceptoUniversidadCuotaAnterior,
        'detallePagoConceptoUniversidadCuotaAnterior',
        {
          planPagoUniversidadId,
          detallePlanPagoConceptoUniversidadId,
        },
      );
    },
    async obtenerPagosUniversidadesCuotaAnterior(planPagoUniversidadId, detallePlanPagoConceptoUniversidadId) {
      await this.obtenerDatosMixin(
        PagoUniversidadService.findAllPagosUniversidadesCuotaAnterior,
        'pagosUniversidadesCuotaAnterior',
        {
          planPagoUniversidadId,
          detallePlanPagoConceptoUniversidadId,
        },
      );
    },
  },
};
